export default "__VITE_ASSET__c617bb13__"